import moment from 'moment'
import { duration as momentDuration } from 'moment'
import type { Moment, Duration } from 'moment'
import { DATE_FORMAT, TIME_FORMAT } from '../contants/date'

export const getDayOfWeekName = (date: Moment) => {
  const weekDay = date.isoWeekday()

  let dayName = '-'

  switch (weekDay) {
    case 1:
      dayName = 'dayOfWeek.monday'
      break
    case 2:
      dayName = 'dayOfWeek.tuesday'
      break
    case 3:
      dayName = 'dayOfWeek.wednesday'
      break
    case 4:
      dayName = 'dayOfWeek.thursday'
      break
    case 5:
      dayName = 'dayOfWeek.friday'
      break
    case 6:
      dayName = 'dayOfWeek.saturday'
      break
    case 7:
      dayName = 'dayOfWeek.sunday'
      break
  }

  return dayName
}

export const getDayOfWeekNameByNumber = (weekDay: number) => {
  let dayName = '-'

  switch (weekDay) {
    case 1:
      dayName = 'dayOfWeek.monday'
      break
    case 2:
      dayName = 'dayOfWeek.tuesday'
      break
    case 3:
      dayName = 'dayOfWeek.wednesday'
      break
    case 4:
      dayName = 'dayOfWeek.thursday'
      break
    case 5:
      dayName = 'dayOfWeek.friday'
      break
    case 6:
      dayName = 'dayOfWeek.saturday'
      break
    case 7:
      dayName = 'dayOfWeek.sunday'
      break
  }

  return dayName
}

export const getDayOfWeekShortName = (weekDay: number) => {
  let dayName = '-'

  switch (weekDay) {
    case 1:
      dayName = 'dayOfWeek.monday-short'
      break
    case 2:
      dayName = 'dayOfWeek.tuesday-short'
      break
    case 3:
      dayName = 'dayOfWeek.wednesday-short'
      break
    case 4:
      dayName = 'dayOfWeek.thursday-short'
      break
    case 5:
      dayName = 'dayOfWeek.friday-short'
      break
    case 6:
      dayName = 'dayOfWeek.saturday-short'
      break
    case 7:
      dayName = 'dayOfWeek.sunday-short'
      break
  }

  return dayName
}

export const getMonthName = (date: Moment) => {
  const month = date.month()

  let monthName = '-'

  switch (month) {
    case 0:
      monthName = 'monthName.january'
      break
    case 1:
      monthName = 'monthName.february'
      break
    case 2:
      monthName = 'monthName.march'
      break
    case 3:
      monthName = 'monthName.april'
      break
    case 4:
      monthName = 'monthName.may'
      break
    case 5:
      monthName = 'monthName.june'
      break
    case 6:
      monthName = 'monthName.july'
      break
    case 7:
      monthName = 'monthName.august'
      break
    case 8:
      monthName = 'monthName.september'
      break
    case 9:
      monthName = 'monthName.october'
      break
    case 10:
      monthName = 'monthName.november'
      break
    case 11:
      monthName = 'monthName.december'
      break
  }

  return monthName
}

export const getMonthNameByNumber = (monthIndex: number) => {
  let monthName = '-'

  switch (monthIndex) {
    case 0:
      monthName = 'monthName.january'
      break
    case 1:
      monthName = 'monthName.february'
      break
    case 2:
      monthName = 'monthName.march'
      break
    case 3:
      monthName = 'monthName.april'
      break
    case 4:
      monthName = 'monthName.may'
      break
    case 5:
      monthName = 'monthName.june'
      break
    case 6:
      monthName = 'monthName.july'
      break
    case 7:
      monthName = 'monthName.august'
      break
    case 8:
      monthName = 'monthName.september'
      break
    case 9:
      monthName = 'monthName.october'
      break
    case 10:
      monthName = 'monthName.november'
      break
    case 11:
      monthName = 'monthName.december'
      break
  }

  return monthName
}

export const getMonthShortNameByNumber = (monthIndex: number) => {
  let monthName = '-'

  switch (monthIndex) {
    case 0:
      monthName = 'monthShortName.january'
      break
    case 1:
      monthName = 'monthShortName.february'
      break
    case 2:
      monthName = 'monthShortName.march'
      break
    case 3:
      monthName = 'monthShortName.april'
      break
    case 4:
      monthName = 'monthShortName.may'
      break
    case 5:
      monthName = 'monthShortName.june'
      break
    case 6:
      monthName = 'monthShortName.july'
      break
    case 7:
      monthName = 'monthShortName.august'
      break
    case 8:
      monthName = 'monthShortName.september'
      break
    case 9:
      monthName = 'monthShortName.october'
      break
    case 10:
      monthName = 'monthShortName.november'
      break
    case 11:
      monthName = 'monthShortName.december'
      break
  }

  return monthName
}

export const getDurationBetweeenDates = (startTime: Date, endTime: Date) => {
  if (startTime == null || moment(startTime).toDate().getFullYear() <= 1) {
    return '--:--'
  }

  let effectiveEndTime = endTime

  if (endTime == null || moment(endTime).toDate().getFullYear() >= 9999) {
    effectiveEndTime = moment(startTime).endOf('day').toDate()
  }

  const duration = momentDuration(
    moment(effectiveEndTime).diff(moment(startTime)),
  )

  if (!duration || isNaN(duration.asMilliseconds())) {
    return '--:--'
  }

  return formatDuration(duration)
}

export const formatDayStartTime = (date: Date) => {
  if (date == null) return ''

  const hours = date.getHours()
  const minutes = date.getMinutes()
  const formattedDuration = `${hours < 10 ? '0' + hours : hours}:${
    minutes < 10 ? '0' + minutes : minutes
  }`
  return formattedDuration
}

export const formatTimespan = (ts: string, hide: boolean = true) => {
  const duration = momentDuration(ts)
  return formatDuration(duration, hide)
}

export const getDifferenceBetweenDatesInDays = (
  startDate: Moment,
  endDate: Moment,
) => {
  const duration = momentDuration(moment(endDate).diff(moment(startDate)))
  const days = Math.abs(Math.floor(duration.asDays()))
  return isNaN(days) ? '-' : days
}

export const getDifferenceBetweenDatesInSeconds = (
  startDate: Moment,
  endDate: Moment,
) => {
  const duration = momentDuration(moment(endDate).diff(moment(startDate)))
  const days = Math.abs(Math.floor(duration.asSeconds()))
  return isNaN(days) ? 0 : days
}

export const formatDurationInDays = (ts: string) => {
  const duration = momentDuration(ts)
  const days = Math.floor(duration.asDays())
  return days
}

export const formatDurationInHours = (ts: string) => {
  const duration = momentDuration(ts)
  const hours = Math.floor(duration.asHours())
  return hours
}

export const formatDate = (date: any) => {
  if (
    date == null ||
    moment(date).toDate().getFullYear() == 1 ||
    moment(date).toDate().getFullYear() == 9999
  ) {
    return '-'
  }
  return moment(date).format(DATE_FORMAT)
}

export const formatDateTime = (date: any) => {
  if (
    date == null ||
    moment(date).toDate().getFullYear() == 1 ||
    moment(date).toDate().getFullYear() == 9999
  ) {
    return '-'
  }
  return moment(date).format(TIME_FORMAT)
}

export const formatTripTimespan = (ts: any) => {
  const duration = momentDuration(ts)

  if (duration.asMinutes() > 0) {
    let formattedDuration = ''

    const days = Math.floor(duration.asDays())
    const hours = duration.hours()
    const minutes = duration.minutes()

    if (days > 0) {
      formattedDuration += `${days}d `
    }
    if (hours > 0) {
      formattedDuration += `${hours}h `
    }
    if (minutes > 0) {
      formattedDuration += `${minutes}m`
    }

    return formattedDuration
  }

  return '-'
}

export const formatQuarter = (date: Moment) => {
  date = moment(date)

  const month = date.month()
  const year = date.year()

  let quarter
  if (month >= 0 && month <= 2) {
    quarter = 'I'
  } else if (month >= 3 && month <= 5) {
    quarter = 'II'
  } else if (month >= 6 && month <= 8) {
    quarter = 'III'
  } else if (month >= 9 && month <= 11) {
    quarter = 'IV'
  }

  const result = `${quarter} ${year}`
  return result
}

export const formatDropdownTimespan = (
  ts: any,
  translate: (string) => string,
) => {
  const duration = momentDuration(ts)

  if (duration.asMinutes() >= 0) {
    let formattedDuration = ''

    const weeks = Math.floor(duration.asWeeks())
    const days = Math.floor(duration.asDays())
    const hours = duration.hours()
    const minutes = duration.minutes()

    if (weeks > 0) {
      formattedDuration += `${weeks} ${translate('dateFormat.week')} `
    }
    if (days > 0 && days % 7 != 0) {
      formattedDuration += `${days} ${days != 1 ? translate('dateFormat.days') : translate('dateFormat.day')} `
    }
    if (hours > 0) {
      formattedDuration += `${hours} ${translate('dateFormat.hour')} `
    }
    if (minutes > 0 || (weeks == 0 && days == 0 && hours == 0)) {
      formattedDuration += `${minutes} ${translate('dateFormat.minute')}`
    }

    return formattedDuration
  }

  return '-'
}

export const formatDuration = (
  duration: Duration,
  hide: boolean = true,
) => {
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  if (hide && hours == 0 && minutes == 0) {
    return '--:--'
  }

  const formattedDuration = `${hours < 10 ? '0' + hours : hours}:${
    minutes < 10 ? '0' + minutes : minutes
  }`
  return formattedDuration
}

export const formatExtendedDuration = (
  duration: Duration,
  showDays: boolean = false,
) => {
  duration = momentDuration(duration)

  if (duration.as('milliseconds') <= 0) {
    return '0'
  }

  const days = Math.floor(duration.asDays())
  const hours = Math.floor(duration.hours())
  const minutes = duration.minutes()

  let formattedDuration = `${hours < 10 ? '0' + hours : hours}:${
    minutes < 10 ? '0' + minutes : minutes
  }`
  if (days > 0) {
    formattedDuration = showDays
      ? `${days}d ${formattedDuration}`
      : `${days}.${formattedDuration}`
  }
  return formattedDuration
}

export const formatSecondsDuration = (duration: Duration) => {
  duration = momentDuration(duration)

  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  let formattedDuration = `${minutes < 10 ? '0' + minutes : minutes}:${
    seconds < 10 ? '0' + seconds : seconds
  }`
  if (hours > 0) {
    formattedDuration = `${hours}:${formattedDuration}`
  }
  return formattedDuration
}
